import { NgxLoggerLevel } from "ngx-logger";
import { commons } from "./environment.commons";

const loggerLevel = "INFO" as keyof typeof NgxLoggerLevel;
const parsedLoggerLevel = NgxLoggerLevel[loggerLevel] ?? NgxLoggerLevel.ERROR;

export const environment = {
  mockEnabled: false,
  httpDevToolsEnabled: false,
  firebaseKeys: {
    apiKey: "AIzaSyA8pameJ4hr7sAQ3yOYbezTizVfmrhSQUk",
    authDomain: "pe-gcp-customercare-02.firebaseapp.com",
    databaseURL: "https://pe-gcp-customercare-02-default-rtdb.firebaseio.com",
    projectId: "pe-gcp-customercare-02",
    storageBucket: "pe-gcp-customercare-02.appspot.com",
    messagingSenderId: "52415902569",
    appId: "1:52415902569:web:c080b833159bb3d72743f8",
    measurementId: "G-4LHFVBX0C0",
    vapidKey:
      "BH_-GZkVKh0MiTLmSrUxgaMruW3nRHL7f8AhHje8kJoH3NbvQZ0KEmkHa_I-E7krI7EhXmLovD7nqJ0GmhmjuLg",
  },
  firebaseProvider: {
    name: "microsoft.com1",
    prompt: "select_account",
    tenant: "5daabe65-ff53-4336-a448-2f61ecf0b059",
    authority: "https://login.microsoftonline.com/common",
    scope: "mail.read",
  },
  API_AUTH: "https://api.cc-irdigital.pe/integracion/cc-auth-svc",
  API_AUTH_LOGIN: "https://api.cc-irdigital.pe/public/cc-auth-svc",
  API_ARIA_CORE: "https://api.cc-irdigital.pe/aria/cc-aria-core",
  BASE_API: "https://api.cc-irdigital.pe",
  CUSTOMER_API: "https://api.cc-irdigital.pe/autoatencion/cc-api-customers",
  ORDERS_API: "https://api.cc-irdigital.pe/chatbot/cc-api-orders/v2",
  UBIGEO_API: "https://api.cc-irdigital.pe/autoatencion/micro-service-ubigeo",
  API_FILE_MANAGER: "https://api.cc-irdigital.pe/integracion/cc-file-svc",

  notificationPollInterval: Number("300000"),
  numItemsPerPage: 10,
  reportsRestrictionsDisabled: String("false") === "true",
  commons,
  maxFileSizeMB: +50,
  timeToastr: 3000,
  loggerLevel: parsedLoggerLevel,
};
